<template>
  <div style="margin-right: 20px">
    <b-button variant="primary" @click="handleClick"
      ><span><i class="fe fe-plus-circle"></i></span> {{ label }}</b-button
    >
  </div>
</template>

<script>
export default {
  name: "ButtonAdd",
  props: {
    label: {
      type: String,
      default: "Add New",
    },
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>
